var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlugHouseholdGMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M39,4H9C6.2431641,4,4,6.2431641,4,9v30c0,2.7568359,2.2431641,5,5,5h30c2.7568359,0,5-2.2431641,5-5V9 C44,6.2431641,41.7568359,4,39,4z M42,39c0,1.6542969-1.3457031,3-3,3H9c-1.6542969,0-3-1.3457031-3-3V9 c0-1.6542969,1.3457031-3,3-3h30c1.6542969,0,3,1.3457031,3,3V39z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28,22V12c0-1.1025391-0.8974609-2-2-2h-4c-1.1025391,0-2,0.8974609-2,2v10c0,1.1025391,0.8974609,2,2,2h4 C27.1025391,24,28,23.1025391,28,22z M22,12h4l0.0019531,10H22V12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38,28H28c-1.1025391,0-2,0.8974609-2,2v4c0,1.1025391,0.8974609,2,2,2h10c1.1025391,0,2-0.8974609,2-2v-4 C40,28.8974609,39.1025391,28,38,28z M38,34l-10,0.0019531V30h10V34z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,28H10c-1.1025391,0-2,0.8974609-2,2v4c0,1.1025391,0.8974609,2,2,2h10c1.1025391,0,2-0.8974609,2-2v-4 C22,28.8974609,21.1025391,28,20,28z M20,34l-10,0.0019531V30h10V34z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlugHouseholdGMedium);
export default __webpack_public_path__ + "static/media/plug-household-g--medium.6e9f856634070f3c3b40fdace32c7042.svg";
export { ForwardRef as ReactComponent };